import endpoints from "../utils/endpoints";
import { Api } from "./api";
import { notificationError, notificationSucces } from "./notification";


export async function getLobbyOrder(){
    let res = [
        {
            id: "",
            order: "",
            image: "",
            title: "",
            tags: []
        },
    ]

    await Api.get(endpoints.getLobbyOrder).then((response) => {
      res = response.data
    }).catch((err: string) => {
      notificationError('Error on getting bingo configuration')
    })
    
    return res
}

export async function updateLobbyOrder(params: any){

    await Api.post(endpoints.updateLobbyOrder, params).then((response) => {
      if(response.status === 200) {
          if(response.data.error) {
              notificationError(`${response.data.message}`)
          } else {
              notificationSucces('Lobby order changed successfully')
          }
      } else {
        notificationError('Could not update lobby order')
      }
    }).catch((err: string) => {
        notificationError('Could not update lobby order')
    })
}

